module.exports = __webpack_public_path__ + "static/manage-leaves-time-offs-app-18dafb2fc69c00dbde7a29d52e00f253.png";